import React, { useState, useRef } from 'react'
import './user.css'
import MUIDataTable from 'mui-datatables'
import Checkbox from '@mui/material/Checkbox'
import { Modal, Grid, TableRow, TableCell } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LocalForm, Control } from 'react-redux-form'
import { Row, Col, Button, FormGroup, Input, Label } from 'reactstrap'
import Match from '../../utilities/validation'
import Switch from '@mui/material/Switch'
import { styled } from '@mui/material/styles'
import { FormControlLabel } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import Loader from '../../components/Loader'
import { useEffect } from 'react'
import { userListing, deleteUsers, updateUserStatus } from '../../actions/user'
import { useDispatch, useSelector } from 'react-redux'
import Moment from 'react-moment'
import 'moment-timezone'
import { format } from 'date-fns'
import TextField from '@mui/material/TextField';
import Pagination from '@mui/material/Pagination'
import Stack from '@mui/material/Stack'

const Users = ({ history }) => {
    const loaders = useSelector((state) => state.loader)
    const [deleteAllButton, setDeleteButton] = useState(false)
    const [openModal, setModal] = useState(false)
    const [open, setDeleteModal] = useState(false)
    const [openStatusModal, setStatusModal] = useState(false)
    const [value, setDateValue] = useState(dayjs('2022-04-17'))
    const [responsive, setResponsive] = useState('simple')
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [deleteIds, setDeleteIds] = useState([])
    const [duration, setDuration] = useState(0)
    const [search, setSearch] = useState('')

    const tableRef = useRef(null);
    const [tableHeight, setTableHeight] = useState('auto');

    useEffect(() => {
        const updateTableHeight = () => {
        if (tableRef.current) {
            const rect = tableRef.current.getBoundingClientRect();
            console.log("rect", rect);
            const remainingHeight = window.innerHeight - rect.top;
            const newHeight = remainingHeight - 60; // Subtract 100px as per requirement
            setTableHeight(newHeight);
            console.log(newHeight);
        }
        };

        updateTableHeight();
        window.addEventListener('resize', updateTableHeight);

        return () => {
        window.removeEventListener('resize', updateTableHeight);
        };
    }, []);

    useEffect(() => {
        if (user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin) {
            history.push("/settings")
        }
    }, [])

    const updatePagination = (e) => {
        setLimit(e.target.value)
        setPage(1)
        setDeleteButton(false)
        setDeleteIds([])
    }

    useEffect(() => {
        const params = { page: page, limit: limit }
        if (search != '' && search != null) {
            params.search = search
        }
        if (duration != 0 && duration != null) {
            params.duration = duration
        }
        dispatch(
            userListing(params, (res) => { }),
        )
    }, [limit, page, duration, search])
    //***********MODAL******************* */
    const handleModal = () => {
        setModal(!openModal)
    }
    const handleDeleteModal = () => {
        setDeleteModal(!open)
    }
    const ModalStatusPopup = () => {
        setStatusModal(!openStatusModal)
    }

    const singleDelete = (e, index) => {
        e.preventDefault()
        e.stopPropagation()
        setDeleteIds([user.user_list[index]['id']])
        setDeleteModal(!open)
    }

    const deleteUser = () => {
        dispatch(
            deleteUsers({ userIds: deleteIds }, (res) => {
                setDeleteModal(!open)
                setDeleteButton(false)
                setDeleteIds([])
                const params = { page: page, limit: limit }
                if (search != '' && search != null) {
                    params.search = search
                }
                if (duration != 0 && duration != null) {
                    params.duration = duration
                }
                dispatch(
                    userListing(params, (res) => { }),
                )
            }),
        )
    }

    const setNewPage = (page) => {
        setPage(page)
        setDeleteButton(false)
        setDeleteIds([])
    }

    const setKeys = (e, id, status) => {
        e.preventDefault()
        e.stopPropagation()
        dispatch(
            updateUserStatus({ id: id, is_active: status }, (res) => {
                const params = { page: page, limit: limit }
                if (search != '' && search != null) {
                    params.search = search
                }
                if (duration != 0 && duration != null) {
                    params.duration = duration
                }
                dispatch(
                    userListing(params, (res) => { }),
                )
            }),
        )
    }

    const [pass, setPass] = useState(true)
    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#625F6D' : '#442580',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#442580',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#442580',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }))

    const style = {
        position: 'absolute',
        top: '50%',
        left: '80%',
        transform: 'translate(-50%, -50%)',
        width: 525,
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        height: '100%',
    }

    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    var newData = []
    //************Setting up paramters for table  */
    useEffect(() => {
        newData = user.user_list.map((item, index) => {
            return [
                item.firstName + ' ' + item.lastName + '     ',
                item.email,
                item.created_at,
                item.school_name,
                item.vehicle_name,
                item.points,
                item.is_active,
                item.dateOfBirth,
                item.gender,
                item.streetAddress,
                item.zip
            ]
        })
        setData(newData)
        setTimeout(() => {
            setData(newData)
        }, 200)
    }, [user.user_list]);

    
    // const StyledMUIDataTable = styled(MUIDataTable)(({ theme }) => ({
    //     '& .MuiPaper-root': {
    //         boxShadow: 'none !important',
    //     },
    //     // '& .tss-1fbujeu-MUIDataTableHeadCell-toolButton': {
    //     '& .MuiTableCell-root.MuiTableCell-head > span > button': {
    //       flex: 'none',
    //       margin: '0',
    //       padding: "6px 16px",
    //     },
    // }));

    const [sortOrder, setSortOrder] = useState({
        name: 'Date Added',
        direction: 'desc',
    });

    const handleTableChange = (action, tableState) => {
        if (action === 'sort') {
            setSortOrder(tableState.sortOrder);
        }
    };

    const columns = [
        {
            name: 'name',
            label: 'Name',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Name</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'email',
            label: 'Email',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            <span>Email</span>
                        </p>
                    )
                },
            },
        },
        {
            name: 'Date Added',
            label: 'Date Added',
            options: {
                filter: true,
                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Date Added
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    const date = data[index][2]
                    return (
                        <div style={{ width: '170px' }}>
                            <span>{format(new Date(parseInt(date)), 'dd MMM yyyy,')} </span>
                            <br /> <span>{format(new Date(parseInt(date)), ' hh:mm a')} </span>{' '}
                        </div>
                    )
                },
            },
        },

        {
            name: 'Community',
            label: 'Community',
            options: {
                filter: true,

                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Community
                        </p>
                    )
                },
            },
        },

        {
            name: 'status',
            label: 'Status',
            headerAlign: 'center',
            options: {
                filter: true,

                customHeadLabelRender: (index) => {
                    return (
                        <p>
                            Status
                        </p>
                    )
                },
                customBodyRenderLite: (index) => {
                    return (
                        <div className="actionField">
                            {data[index][6] == true ? (
                                <Button
                                    className="activeButton"
                                    title="Click to Inactivate"
                                    onClick={(e) =>
                                        setKeys(e, user.user_list[index]['id'], 'false')
                                    }
                                >
                                    Active
                                </Button>
                            ) : (
                                <Button
                                    className="inActiveButton"
                                    title="Click to Activate"
                                    onClick={(e) => setKeys(e, user.user_list[index]['id'], 'true')}
                                >
                                    Inactive
                                </Button>
                            )}
                        </div>
                    )
                },
            },
        },
        {
            name: 'action',
            label: 'Action',
            headerAlign: 'left',
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (index) => {
                    return (
                        <div className="actionField">
                            <Button
                                className="deleteButton"
                                title="Delete"
                                onClick={(e) => singleDelete(e, index)}
                            >
                                <img src={require('../../assets/images/delete icon.svg').default} />
                            </Button>
                        </div>
                    )
                },
            },
        },
    ]

    const options = {
        //  filterType: 'checkbox',
        title: 'Pie Chart',
        filter: false,
        sort: true,
        sortOrder: sortOrder,
        // onTableChange: handleTableChange,
        print: false,
        viewColumns: false,
        download: false,
        pagination: false,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 30],
        caseSensitive: false,
        search: false,
        jumpToPage: true,
        tableBodyHeight: tableHeight,
        tableBodyMaxHeight: "none",
        count: user.total_users,
        onChangePage: (currentPage) => {
            setPage(currentPage + 1)
            return
        },
        onChangeRowsPerPage: (numberOfRows) => {
            setLimit(numberOfRows)
        },

        textLabels: {
            pagination: {
                next: 'Next Page',
                previous: 'Previous Page',
                displayRows: 'of',
            },
        },

        onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {

            if (allRowsSelected.length > 0) {
                const newarr = allRowsSelected.map((item, index) => {
                    if (user.user_list[item['dataIndex']]) {
                        return user.user_list[item['dataIndex']]['id']
                    }
                    else {
                        setDeleteButton(false)
                        return;
                    }
                })
                if (newarr.length > 0 && newarr[0]) {
                    setTimeout(() => {
                        setDeleteIds(newarr)
                    })
                    setDeleteButton(true)
                }
                else {
                    setDeleteButton(false)
                }
            } else {
                setDeleteButton(false)
            }
        },
        responsive: 'standard',
        expandableRows: true,
        expandableRowsHeader: false,
        expandableRowsOnClick: true,
        // isRowExpandable: (dataIndex, expandedRows) => {
        //   if (dataIndex === 3 || dataIndex === 4) return false;

        //   // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
        //   if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0)
        //     return false;
        //   return true;
        // },
        // rowsExpanded: [0, 1],
        renderExpandableRow: (rowData, rowMeta) => {
            const colSpan = rowData.length + 1
            const dob = data[rowMeta.dataIndex][7];
            // Split the date string based on the 'T' character
            const dateParts = dob.split('T');
            const date = dateParts[0];

            // Split the date parts into year, month, and day
            const [year, month, day] = date.split('-');

            // Format the date as 'MM-DD-YYYY'
            const formatteddob = `${month}/${day}/${year}`;
            return (
                <TableRow>
                    <TableCell colSpan={colSpan}>
                        {' '}
                        <div class="container1 descriptoonBoxTable">
                            <div>
                                <p>
                                    Name: <span class="promo">{data[rowMeta.dataIndex][0]}</span>
                                </p>
                                <p>
                                    Created Date:{' '}
                                    <span class="promo">
                                        {format(
                                            new Date(parseInt(data[rowMeta.dataIndex][2])),
                                            'dd MMM yyyy ,  hh:mm a',
                                        )}
                                    </span>
                                </p>
                                <p>
                                    BirthYear:{' '}
                                    <span class="promo">
                                        {format(
                                            new Date(formatteddob),
                                            'yyyy',
                                        )}
                                    </span>
                                </p>
                                <p>
                                    Email: <span class="promo">{data[rowMeta.dataIndex][1]}</span>
                                </p>
                                <p>
                                    Community: <span class="promo">{data[rowMeta.dataIndex][3]}</span>
                                </p>

                            </div>
                            <div>
                                <p>
                                    Gender: <span class="promo">{data[rowMeta.dataIndex][8] == 1 ? "Male" : data[rowMeta.dataIndex][8] == 2 ? "Female" : "Prefer not to say"}</span>
                                </p>
                                <p>
                                    Vehicle: <span class="promo">{data[rowMeta.dataIndex][4]}</span>
                                </p>
                                <p>
                                    Hive Points:{' '}
                                    <span class="promo">{data[rowMeta.dataIndex][5]}</span>
                                </p>
                                <p>
                                    Zipcode:{' '}
                                    <span class="promo">{data[rowMeta.dataIndex][10]}</span>
                                </p>

                                <p>
                                    Address: <span class="promo">{data[rowMeta.dataIndex][9]}</span>
                                </p>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
            )
        },
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),
    }
    const setSearchValue = (data) => {
        setSearch(data)
        setPage(1)
    }

    const CustomCheckbox = (props) => {
        let newProps = Object.assign({}, props)
        newProps.color = props['data-description'] === 'row-select' ? 'secondary' : 'primary'

        if (props['data-description'] === 'row-select') {
            return <Checkbox />
        } else {
            return <Checkbox {...newProps} />
        }
    }

    useEffect(() => {
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', 'true');
            window.location.reload();
        }
    }, []);

    return (
        <div className="userPageWrapper">
            <div className="userPage userPageWithList">
                <Loader loading={loaders.isFetching} />

                <div className="scroll-fix">
                    <div className="titlediv">
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={6}>
                                <div style={{ display: 'flex' }}>
                                    <div>
                                        <p className="headinguser">Users List</p>
                                        <p className="subheadinggraph">
                                            User of Climate Mobility & Safety
                                        </p>
                                    </div>
                                </div>
                            </Grid>
                            <Grid
                                style={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    display: 'flex',
                                }}
                                item
                                xs={12}
                                sm={12}
                                md={6}
                            >
                                <Grid container spacing={1}>
                                    <Grid
                                        style={{ alignItems: 'center', display: 'flex' }}
                                        item
                                        xs={12}
                                        sm={12}
                                        md={3}
                                    >
                                        <Button
                                            style={{
                                                visibility: deleteAllButton
                                                    ? deleteAllButton
                                                    : 'hidden',
                                            }}
                                            title="Delete All Selected Rows"
                                            className="deleteAll"
                                            onClick={() => handleDeleteModal()}
                                        >
                                            <i className="   deleteButton">
                                                <img
                                                    src={require('../../assets/images/delete icon.svg').default}
                                                />
                                            </i>{' '}
                                            Delete Selected
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={5}>
                                        <div className="search-wrapper">
                                            <TextField
                                                size='medium'
                                                placeholder="Search"
                                                id="outlined-size-normal"
                                                defaultValue=""
                                                className='selectNew'
                                                onChange={(e) => setSearchValue(e.target.value)}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}>
                                        <select
                                            className="selectoptioninmerchant"
                                            onChange={(e) => setDuration(e.target.value)}
                                            placeholder="Recent Merchants"
                                            type="select"
                                        >
                                            <option value={0}>All Users</option>
                                            <option value={7}>Recent Users</option>
                                            <option value={30}>1 Month</option>
                                            <option value={180}>6 Months</option>
                                            <option value={360}>1 Year</option>
                                        </select>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                    <div className="pagination-wrapper">
                        <div className="pagination">
                            <p>
                                Showing {user.user_list.length} out of {user.total_users} users{' '}
                            </p>
                        </div>

                        <Stack spacing={2}>
                            <Pagination
                                count={Math.ceil(user.total_users / limit)}
                                page={page}
                                onChange={(e, value) => setNewPage(value)}
                                color="primary"
                            />
                        </Stack>

                        <div className="pagination2">
                            <p>Rows Per Page</p>
                            <select className='pagination-select'
                                onChange={(e) => updatePagination(e)}>
                                <option selected={limit == 10}>10</option>
                                <option selected={limit == 20}>20</option>
                                <option selected={limit == 30}>30</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div ref={tableRef} style={{ overflowY: 'auto', height: tableHeight }}>
                    <MUIDataTable
                        className="custommuitablestyle"
                        columns={columns}
                        data={data}
                        responsive="simple"
                        // components={{
                        //   Checkbox: CustomCheckbox,
                        // }}
                        //title='Data shown for 100 Countries in Below Table'
                        options={options}
                    />
                </div>

                <Modal
                    open={openModal}
                    onClose={handleModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style} className="popupModal">
                        <Typography
                            id="modal-modal-title"
                            className="popuptitle"
                            variant="h6"
                            component="h2"
                        >
                            Add New User
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <LocalForm
                                model="user"
                            // onSubmit={(values) => handleLogin(values)}
                            >
                                <Row>

                                    <Col className="column" sm="12" md="12">
                                        <FormGroup>
                                            <Label>Name</Label>

                                            <div style={{ display: 'flex' }}>
                                                <Control.text
                                                    model="user.name"
                                                    className="form-control nameField input-field"
                                                    id="user.username"
                                                    placeholder="Enter Full Name"
                                                // errors={{
                                                //   emptyEmail:(val) => !val ,
                                                //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                // }}
                                                />
                                            </div>

                                        </FormGroup>
                                    </Col>
                                    <Col className="column" sm="12" md="12">
                                        <FormGroup>
                                            <Label>Email</Label>

                                            <div style={{ display: 'flex' }}>
                                                <Control.text
                                                    model="user.email"
                                                    className="form-control nameField input-field"
                                                    id="user.email"
                                                    placeholder="Enter Email"
                                                    errors={{
                                                        emptyEmail: (val) => !val,
                                                        invalidEmail: (val) =>
                                                            val && !Match.validateEmail(val),
                                                    }}
                                                />
                                            </div>

                                        </FormGroup>
                                    </Col>
                                    <Col className="column" sm="12" md="12">
                                        <FormGroup>
                                            <Label>Password</Label>

                                            <div
                                                className="passwordfield"
                                                style={{ display: 'flex' }}
                                            >
                                                <Control.text
                                                    model="user.password"
                                                    className="form-control  password input-field"
                                                    id="user.password"
                                                    placeholder="Create Password"
                                                    type={pass ? 'password' : 'text'}
                                                // errors={{
                                                //   emptyEmail:(val) => !val ,
                                                //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                // }}
                                                />
                                                {pass && (
                                                    <i
                                                        class="  icons icon passwordicon"
                                                        onClick={() => setPass(false)}
                                                    >
                                                        <img
                                                            src={require('../../assets/images/eye-slash.png')}
                                                        />
                                                    </i>
                                                )}

                                                {!pass && (
                                                    <i
                                                        class="  icons icon passwordicon "
                                                        onClick={() => setPass(true)}
                                                    >
                                                        <img
                                                            src={require('../../assets/images/eye.png')}
                                                        />
                                                    </i>
                                                )}
                                            </div>

                                        </FormGroup>
                                    </Col>

                                    <Col className="column" sm="12" md="12">
                                        <FormGroup>
                                            <Label>Group</Label>

                                            <div style={{ display: 'flex' }}>
                                                <Control.select
                                                    model="user.groups"
                                                    className="form-control selectfield input-field"
                                                    id="user.group"
                                                    placeholder="Enter Full Name"
                                                // errors={{
                                                //   emptyEmail:(val) => !val ,
                                                //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                // }}
                                                >
                                                    <option value="red">Select Group</option>
                                                    <option value="green">Group 1</option>
                                                    <option value="blue">Group 2</option>
                                                </Control.select>
                                            </div>

                                        </FormGroup>
                                    </Col>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <Col className="column" sm="8" md="8">
                                                <FormGroup style={{ gap: '10px', display: 'flex' }}>
                                                    <Label>Added Date</Label>

                                                    <div style={{ display: 'flex' }}>
                                                        <Control.text
                                                            model="user.name"
                                                            className="form-control nameField input-field"
                                                            id="user.username"
                                                            placeholder="Enter Full Name"
                                                        // errors={{
                                                        //   emptyEmail:(val) => !val ,
                                                        //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                        // }}
                                                        />
                                                    </div>

                                                </FormGroup>
                                            </Col>
                                            <Col className="column" sm="12" md="12">
                                                <FormGroup>
                                                    <Label>Email</Label>

                                                    <div style={{ display: 'flex' }}>
                                                        <Control.text
                                                            model="user.email"
                                                            className="form-control nameField input-field"
                                                            id="user.email"
                                                            placeholder="Enter Email"
                                                            errors={{
                                                                emptyEmail: (val) => !val,
                                                                invalidEmail: (val) =>
                                                                    val &&
                                                                    !Match.validateEmail(val),
                                                            }}
                                                        />
                                                    </div>

                                                </FormGroup>
                                            </Col>
                                            <Col className="column" sm="12" md="12">
                                                <FormGroup>
                                                    <Label>Password</Label>

                                                    <div
                                                        className="passwordfield"
                                                        style={{ display: 'flex' }}
                                                    >
                                                        <Control.text
                                                            model="user.password"
                                                            className="form-control  password input-field"
                                                            id="user.password"
                                                            placeholder="Create Password"
                                                            type={pass ? 'password' : 'text'}
                                                        // errors={{
                                                        //   emptyEmail:(val) => !val ,
                                                        //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                        // }}
                                                        />
                                                        {pass && (
                                                            <i
                                                                class="  icons icon passwordicon"
                                                                onClick={() => setPass(false)}
                                                            >
                                                                <img
                                                                    src={require('../../assets/images/eye-slash.png')}
                                                                />
                                                            </i>
                                                        )}

                                                        {!pass && (
                                                            <i
                                                                class="  icons icon passwordicon "
                                                                onClick={() => setPass(true)}
                                                            >
                                                                <img
                                                                    src={require('../../assets/images/eye.png')}
                                                                />
                                                            </i>
                                                        )}
                                                    </div>

                                                </FormGroup>
                                            </Col>

                                            <Col className="column" sm="12" md="12">
                                                <FormGroup>
                                                    <Label>Group</Label>

                                                    <div style={{ display: 'flex' }}>
                                                        <Control.select
                                                            model="user.groups"
                                                            className="form-control selectfield input-field"
                                                            id="user.group"
                                                            placeholder="Enter Full Name"
                                                        // errors={{
                                                        //   emptyEmail:(val) => !val ,
                                                        //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                        // }}
                                                        >
                                                            <option value="red">
                                                                Select Group
                                                            </option>
                                                            <option value="green">Group 1</option>
                                                            <option value="blue">Group 2</option>
                                                        </Control.select>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col className="column" sm="8" md="8">
                                                <FormGroup style={{ gap: '10px', display: 'flex' }}>
                                                    <div>
                                                        <Label>Added Date</Label>

                                                        <div style={{ display: 'flex' }}>
                                                            <Control.text
                                                                model="user.date"
                                                                className="form-control dateField input-field"
                                                                id="user.date"
                                                                placeholder="05 August 2023"
                                                            // errors={{
                                                            //   emptyEmail:(val) => !val ,
                                                            //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                            // }}
                                                            />
                                                            <i
                                                                class="  icons icon dateicon"
                                                                onClick={() => setPass(false)}
                                                            >
                                                                <img
                                                                    src={require('../../assets/images/calendar-2.png')}
                                                                />
                                                            </i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Label>Time</Label>

                                                        <div style={{ display: 'flex' }}>
                                                            <Control.text
                                                                model="user.time"
                                                                className="form-control timeField input-field"
                                                                id="user.time"
                                                                placeholder="4:00 PM"
                                                            // errors={{
                                                            //   emptyEmail:(val) => !val ,
                                                            //   invalidEmail: (val) => val && !Match.validateEmail(val)
                                                            // }}
                                                            />
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            <Col
                                                sm="12"
                                                style={{ marginTop: '5px', display: 'inline-grid' }}
                                            >
                                                <Label>Active</Label>
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch sx={{ m: 1 }} defaultChecked />
                                                    }
                                                />
                                            </Col>
                                            <Col sm="12 form-button-spacing">
                                                <div>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary btn-block "
                                                    >
                                                        Add User
                                                    </button>
                                                </div>
                                            </Col>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <Col
                                                sm="12"
                                                style={{ marginTop: '5px', display: 'inline-grid' }}
                                            >
                                                <Label>Active</Label>
                                                <FormControlLabel
                                                    control={
                                                        <IOSSwitch sx={{ m: 1 }} defaultChecked />
                                                    }
                                                />
                                            </Col>
                                        </Grid>
                                    </Grid>
                                    <Col sm="12 form-button-spacing">
                                        <div>
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-block "
                                            >
                                                Add User
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </LocalForm>
                        </Typography>
                    </Box>
                </Modal>

                <Modal
                    open={open}
                    onClose={handleDeleteModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleDeletePopup} className="deletePopup">
                        <div className="iconshadow">
                            <i className="  deleteIconPopup">
                                <button>
                                    <img
                                        height={22}
                                        src={require('../../assets/images/delete icon.svg').default}
                                    />
                                </button>
                            </i>
                        </div>
                        <div className="textDeletePopup">
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Are you Sure?
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Are you sure you want delete this? This action cannot be undone.
                            </Typography>

                            <Typography>
                                <div className="buttonGroupDelete">
                                    <button
                                        className="btn btn-primary btn-block cancelButton"
                                        onClick={() => handleDeleteModal()}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary btn-block deleteButtonUser"
                                        onClick={() => deleteUser()}
                                    >
                                        <img src={require('../../assets/images/DeleteWhite.png')} />{' '}
                                        Delete
                                    </button>
                                </div>
                            </Typography>
                        </div>
                    </Box>
                </Modal>
                <Modal
                    open={openStatusModal}
                    onClose={ModalStatusPopup}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleDeletePopup} className="deletePopup">
                        <div className="iconshadow">
                            <i className="  deleteIconPopup">
                                <button>
                                    <img src={require('../../assets/images/delete icon.svg').default} />
                                </button>
                            </i>
                        </div>
                        <div className="textDeletePopup">
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Are you Sure?
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Are you sure you want to change status?
                            </Typography>

                            <Typography>
                                <div className="buttonGroupDelete">
                                    <button
                                        className="btn btn-primary btn-block cancelButton"
                                        onClick={() => ModalStatusPopup()}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="btn btn-primary btn-block deleteButtonUser"
                                        onClick={() => deleteIds()}
                                    >
                                        <img src={require('../../assets/images/DeleteWhite.png')} />{' '}
                                        Delete
                                    </button>
                                </div>
                            </Typography>
                        </div>
                    </Box>
                </Modal>
            </div>
        </div>
    )
}

export default Users
